import { fetchApiJson, trackError, trackUserEvent } from '@vend/utilities'

type CancelPaymentRequestResponse = {
  success: boolean
  error?: string
}

/**
 * Cancel a payment request via the invoicing proxy
 *
 * @param paymentRequestId {string} The payment request ID to cancel
 * @return {Promise<CancelPaymentRequestResponse>} A promise resolved when payment request has been cancelled
 */
export const cancelPaymentRequest = async (
  paymentRequestId: string
): Promise<CancelPaymentRequestResponse> => {
  if (!paymentRequestId) {
    return {
      success: false,
      error: 'Payment request ID is required to cancel.',
    }
  }

  try {
    await fetchApiJson(
      `/api/2.0/invoicing/payment-requests/${paymentRequestId}/cancel`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      }
    )

    // Track successful payment request cancellation
    trackUserEvent('Web Register', 'Payment Request Cancelled', {
      paymentRequestId,
    })

    return {
      success: true,
    }
  } catch (err: any) {
    // Track and log the error
    const errorMessage = err?.message || 'Unknown error occurred'
    trackError('Payment Request Cancellation Error', errorMessage, {
      paymentRequestId,
    })

    return {
      success: false,
      error: errorMessage,
    }
  }
}
